// Compact label for the angled x-axis ticks on the Sentiment Composite chart
// (markup #78). The original implementation also abbreviated "(search on)" to
// "(on)" to save horizontal space, but that left the chart axis disagreeing
// with the Provider Scorecard and the chart's own tooltip (markup #108).
// Keep the full "(Search on)" / "(Search off)" suffix (title-cased per the
// follow-up to #108) and rely on the ellipsis truncation + angled labels to
// fit long names like "Google AI Overviews".

import { prettifyProviderLabel } from './providerColors';

export function shortenProviderTick(name, max) {
  if (!name) return '';
  let s = prettifyProviderLabel(String(name));
  if (max && s.length > max) s = `${s.slice(0, max - 1).trimEnd()}…`;
  return s;
}

// Maps a viewport width (in CSS pixels) to a label-rendering mode for the
// Sentiment Composite XAxis. Three tiers reflect the actual breakpoints
// where labels start colliding:
//   * >=1800px — horizontal labels, full name, no truncation
//   * 1200-1799 — angled, 14-char ellipsis truncation
//   * <1200 — angled, 10-char ellipsis truncation
export function pickLabelMode(width) {
  const w = Number.isFinite(width) ? width : 0;
  if (w >= 1800) return 'horizontal';
  if (w >= 1200) return 'angled';
  return 'angled-narrow';
}
